namespace app.openState {
    "use strict";

    import IStateService = angular.ui.IStateService;
    
    export class OpenStateController {

        public currentStateChangeRequest;
        
        public hide: boolean = false;

        /** @ngInject **/
        constructor(
            private $state: IStateService,
            private $stateParams: ng.ui.IStateParamsService,
            private $http, 
            private properties
        ) {

        }

        public $onInit(): void { 
            var idRoute = this.$stateParams.idRoute; 
            this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/routes", { cache: true }).then((routes) => {
                let route = routes.data.find((x: any) => x.id == idRoute);
                this.$state.go(route.stateName);
            });
        }
    }

    angular
        .module('app.openState')
        .controller('app.openState.OpenStateController', OpenStateController);
}